import React from 'react'
import { Link } from 'react-router-dom'

const FinalThought = ({ data }) => {
    return (
        <div>
            <h4 className="heading">{data?.heading}</h4>
            {data?.paragraph?.map((item, index) => {
                return (
                    <div key={index} className='mb-3'>
                        <p className="paragraph m-0">{item?.text}<b><Link className="paragraph fw-bold text-decoration-none" to={item?.link}>
                            {item?.linkText}
                        </Link>{item?.boldText}</b>{item?.text1}</p>
                        {item?.italicText && <p className="paragraph m-0 fst-italic">{item?.italicText}</p>}
                    </div>
                )
            })}
        </div>
    )
}
export default FinalThought
